import { useState, useEffect, useRef } from 'react'
import './Navbar.css'

const SECTIONS = ['inicio', 'servicos', 'sobre-nos', 'porque-makhowo', 'valores', 'garantias', 'clientes', 'parceiros', 'contactenos'];

const menuItems: { label: string; href: string }[] = [
  { label: 'Início', href: '#inicio' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre Nós', href: '#sobre-nos' },
  { label: 'Contacto', href: '#contactenos' },
];


export default function Navbar() {
  const [menuAberto, setMenuAberto] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [activeSection, setActive] = useState('inicio')
  const observerRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const options: IntersectionObserverInit = {
      rootMargin: '-40% 0px -55% 0px',
      threshold: 0,
    }
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id)
      })
    }, options)
    SECTIONS.forEach((id) => {
      const el = document.getElementById(id)
      if (el) observerRef.current!.observe(el)
    })
    return () => observerRef.current?.disconnect()
  }, [])

  useEffect(() => {
    if (menuAberto) {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
    }
    return () => {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
    }
  }, [menuAberto])

  const toggleMenu = () => setMenuAberto((v) => !v)
  const fecharMenu = () => setMenuAberto(false)

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    const sectionId = href.replace('#', '')
    if (window.location.pathname === '/') {
      const el = document.getElementById(sectionId)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    } else {
      window.location.href = `/#${sectionId}`
    }
  }

  const isActive = (href: string) => {
    const section = href.replace('#', '')
    if (section === activeSection) return true
    if (section === 'sobre-nos' && ['porque-makhowo', 'valores', 'garantias', 'clientes', 'parceiros'].includes(activeSection)) {
      return true
    }
    return false
  }

  return (
    <>
      {/* Desktop Navbar */}
      <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
        <div className="nav-wrapper">

          <div className="logo">
            <a href="#inicio" onClick={(e) => scrollTo(e, '#inicio')}>
              <img
                src="/logo.png"
                className="logo-svg"
                alt="Makhowo Seguros"
              />
            </a>
          </div>

          <ul id="menu">
            {menuItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={isActive(item.href) ? 'active' : ''}
                  onClick={(e) => scrollTo(e, item.href)}
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="/cotacoes"
                className="nav-cta"
              >
                Pedir Cotação
              </a>
            </li>
          </ul>

        </div>
      </nav>

      {/* Hamburger */}
      <button
        className={`menuIcon${menuAberto ? ' toggle' : ''}`}
        onClick={toggleMenu}
        aria-label={menuAberto ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={menuAberto}
      >
        <span className="icon-bars" />
      </button>

      {/* Mobile Overlay */}
      <div
        className={`overlay-menu${menuAberto ? ' open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!menuAberto}
      >
        <ul id="menu-mobile">
          {menuItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={(e) => { scrollTo(e, item.href); fecharMenu() }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="/cotacoes"
          className="overlay-cta"
          onClick={() => fecharMenu()}
        >
          Pedir Cotação
        </a>
      </div>
    </>
  )
}